Object.defineProperty(exports, "__esModule", {
  value: true
});

function TermQuery(key, value) {
  var _a;

  return {
    term: (_a = {}, _a[key] = value, _a)
  };
}

exports.TermQuery = TermQuery;